module.exports = {
      id: "vikatanspl-usage",
      viewBox: "0 0 30.9 32",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#vikatanspl",
      toString: function () {
        return this.url;
      }
    }